module.exports = __webpack_public_path__ + "static/img/bannermariomachucanew.23af409.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bannermariomachucanew.jpeg
// module id = 2UNz
// module chunks = 1